import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 900;

/**
 * Matches the app's one CSS breakpoint (see styles.css). Components that
 * need to skip mounting entirely on mobile — not just hide via CSS — read
 * this before rendering anything, e.g. the drill-down maps: React.lazy's
 * dynamic import is only triggered once the lazy component actually
 * renders, so gating on this hook is what keeps the map libraries and the
 * topojson fetch out of the mobile network payload, not just off-screen.
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches,
  );
  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    const onChange = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return isMobile;
}
